import { Box, Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import CancelPresentationIconButton from "../../../common/components/Buttons/CancelPresentationIconButton";
import { ModalStyleFeedback } from "../../../common/components/ModalStyle";
import {
  getDoctorTimeSlotsByDepartmentIdAndUnitId,
  saveRescheduleAppointment,
} from "./services/AppointmentServices";
import DatePickerField from "../../../common/components/FormFields/DatePickerFieldNew";
import { useForm } from "react-hook-form";
import { format } from "date-fns";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import ConfirmationModal from "../../../common/components/ConfirmationModal";
import {
  errorAlert,
  successAlert,
  warningAlert,
} from "../../../common/components/Toasts/CustomToasts";

const RescheduleAppointmentModal = (props) => {
  const getLoggedUserInfo = JSON.parse(localStorage?.getItem("userInfo"));
  const {
    openRescheduleAppointmentModal,
    setOpenRescheduleAppointmentModal,
    selectedRow,
    setSelectedRow,
    setOpenBackdrop,
    populateTable,
  } = props;

  const defaultValues = {
    appointmentDate: null,
  };

  const { control, watch, reset, register, setValue } = useForm({
    mode: "onChange",
    defaultValues: defaultValues,
  });

  let getAppointmentDate = watch("appointmentDate");

  const [slotsList, setSlotsList] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [openPostModal, setOpenPostModal] = useState(false);

  const getRescheduleAppointmentSlots = (date) => {
    getDoctorTimeSlotsByDepartmentIdAndUnitId(
      date,
      selectedRow?.DepartmentId,
      getLoggedUserInfo?.unitId,
      selectedRow?.DoctorId,
    ).then((response) => {
      setSlotsList(response?.data?.result[0]?.visitSlots);
    });
  };

  const rescheduleAppointment = () => {
    setOpenBackdrop(true);
    setOpenPostModal(false);
    saveRescheduleAppointment({
      doctorId: selectedRow?.DoctorId,
      appointmentId: selectedRow?.AppointmentID,
      rescheduleDate: format(
        new Date(getAppointmentDate),
        "yyyy-MM-dd'T'00:00:00.000'Z'",
      ),
      fromTime: `1900-01-01T${selectedSlot?.fromTwoFourTime}:00.000Z`,
      toTime: `1900-01-01T${selectedSlot?.toTwoFourTime}:00.000Z`,
    })
      .then((response) => {
        successAlert(response?.data?.message);
        setOpenBackdrop(false);
        setSelectedSlot(null);
        setSlotsList([]);
        reset(defaultValues);
        setOpenRescheduleAppointmentModal(false);
        populateTable();
      })
      .catch((error) => {
        errorAlert(error?.data?.result?.message || error?.message);
        setOpenBackdrop(false);
      });
  };

  useEffect(() => {
    if (selectedRow?.["Appointment Date"]) {
      getRescheduleAppointmentSlots(
        selectedRow?.["Appointment Date"]?.split("-")?.reverse()?.join("-"),
      );
      setValue(
        "appointmentDate",
        new Date(
          selectedRow?.["Appointment Date"]?.split("-")?.reverse()?.join("-"),
        ),
      );
    }
  }, [selectedRow]);
  return (
    <>
      <Modal open={openRescheduleAppointmentModal}>
        <Box sx={ModalStyleFeedback} className="w-[85%] max-h-[90%] space-y-2">
          <div className="flex justify-between">
            <label className="font-semibold">Reschedule Appointment</label>
            <button
              type="button"
              onClick={() => {
                setOpenRescheduleAppointmentModal(false);
                reset(defaultValues);
                setSlotsList([]);
                setSelectedRow(null);
              }}
            >
              <CancelPresentationIconButton />
            </button>
          </div>
          <div className="flex justify-between bg-[#F1F1F1] p-2 rounded text-sm">
            <div className="flex items-center">
              <label className="font-semibold">Patient Name</label>
              <label>&nbsp;:&nbsp;{selectedRow?.["Patient Name"]}</label>
            </div>
            <div className="flex items-center">
              <label className="font-semibold">Contact No.</label>
              <label>&nbsp;:&nbsp;{selectedRow?.["Contact No"]}</label>
            </div>
            <div className="flex items-center">
              <label className="font-semibold">Doctor Name</label>
              <label>&nbsp;:&nbsp;{selectedRow?.["Doctor Name"]}</label>
            </div>
          </div>
          <div className="w-40">
            <DatePickerField
              control={control}
              name="appointmentDate"
              label="Appointment Date"
              inputFormat="dd-MM-yyyy"
              inputRef={{
                ...register("appointmentDate", {
                  onChange: (e) => {
                    getRescheduleAppointmentSlots(
                      format(e?.target?.value, "yyyy-MM-dd"),
                    );
                  },
                }),
              }}
            />
          </div>
          <div>
            {slotsList?.length > 0 ? (
              <div className="grid grid-cols-4 lg:grid-cols-6 xl:grid-cols-10 2xl:grid-cols-12 gap-2">
                {slotsList?.map((slot) => (
                  <button
                    type="button"
                    disabled={slot?.isBooked === true}
                    className={`border border-customBlue rounded ${slot?.isBooked === true ? "bg-gray-300 text-gray-500" : slot?.fromTime === selectedSlot?.fromTime ? "bg-customBlue text-white" : "bg-white text-customBlue"}`}
                    onClick={() => {
                      setSelectedSlot(slot);
                    }}
                  >
                    <span>{slot?.fromTime}</span>
                  </button>
                ))}
              </div>
            ) : (
              <div className="h-28 font-semibold flex items-center justify-center border rounded">
                No Slots Available...
              </div>
            )}
          </div>
          <div className="flex justify-end ">
            <CommonButton
              type="button"
              label="Reschedule Appointment"
              className="bg-customGreen text-white"
              onClick={() => {
                if (selectedSlot !== null) {
                  setOpenPostModal(true);
                } else {
                  warningAlert("select slot first...!");
                }
              }}
            />
          </div>
        </Box>
      </Modal>
      <ConfirmationModal
        confirmationOpen={openPostModal}
        confirmationHandleClose={() => setOpenPostModal(false)}
        confirmationSubmitFunc={rescheduleAppointment}
        confirmationLabel="Confirmation "
        confirmationMsg="Are you sure want to reschedule appointment ?"
        confirmationButtonMsg="Confirm"
      />
    </>
  );
};

export default RescheduleAppointmentModal;
